import { register } from "simple-body-validator";

import patterns from "@/constants/patterns";

// RUT rules

register("rut_format", (rut) => {
  if (!rut) return false;
  if (rut.length <= 0) return false;
  return !!rut.match(patterns.rut);
});

register("rut_exists", (rut) => {
  if (!rut) return false;
  const matchResult = rut.match(patterns.rut);
  if (!matchResult || matchResult.length <= 2) return false;
  const [, rutDigits, rutDv] = matchResult;

  const previousModule = Array.from(rutDigits)
    .reverse()
    .reduce((acc, cur, i) => {
      const num = Number(cur);
      if (isNaN(num)) return acc;
      return acc + num * ((i % 6) + 2);
    }, 0);

  let mod11 = String(11 - (previousModule % 11));
  if (mod11 === "11") mod11 = "0";
  else if (mod11 === "10") mod11 = "k";
  return rutDv.toLowerCase() === mod11;
});
